export const environment = {
  graphqlUri: 'https://ges-reseau-gateway-api.rec.finzzle-groupe.com/graphql',

  auth: {
    clientId: 'wNPaIMghee.gestres',
    loginUrl: 'https://reseau-rec.prodemial.fr/cas/oauth2.0/authorize',
    logoutUrl: 'https://reseau-rec.prodemial.fr/cas/logout',
    tokenUrl: 'https://reseau-rec.prodemial.fr/cas/oauth2.0/token',
  },

  roles: {
    shmAdGroups: ['APP_GESTION_RESEAU_RESP-HP', 'APP_GESTION_RESEAU_GEST-HP'],
    gcomAdGroups: ['APP_GESTION_RESEAU_GCOM_RESP-HP', 'APP_GESTION_RESEAU_GCOM_GEST-HP'],
  },
};
